var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005EAD",
    d: "M21.2178 31.7034H10.4629v-1.7116h10.7549v1.7116Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C27",
    d: "M15.84.183285c-5.6994 0-10.33597 4.636605-10.33597 10.336015 0 2.3311 1.63491 6.173 4.86037 11.4194 2.3584 3.8353 4.7497 7.0723 4.7734 7.1045l.7022.9485.7023-.9485c.0237-.0322 2.4149-3.2692 4.7734-7.1045 3.2254-5.2464 4.8603-9.0883 4.8603-11.4194C26.176 4.81989 21.5394.183285 15.84.183285Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE17",
    d: "M15.84 4.98105c-2.9652 0-5.3777 2.41255-5.3777 5.37775 0 2.9658 2.4125 5.3778 5.3777 5.3778 2.9653 0 5.3778-2.412 5.3778-5.3778 0-2.9652-2.4125-5.37775-5.3778-5.37775Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7722cc88d6d4408891f088bfe527c911.svg";
export { ForwardRef as ReactComponent };